<template>
  <v-card
    flat
    tile
    class="elevation-0"
    style="height:100%; background-color:transparent">

    <v-card-title class="subtitle-1 py-2">
      <strong>Avaliação</strong>
    </v-card-title>

    <v-card-text
      class="py-0"
      style="background-color:transparent;">

      <v-form
        v-if="callObj"
        ref="formEvaluationOne"
        lazy-validation>
        <v-row class="py-0 my-0">

          <v-col
            class="py-0 my-0"
            cols="6">
            <strong v-if="fixaSelected.victim">Paciente: {{ fixaSelected.victim.name }} - {{ fixaSelected.victim.age }} - {{ fixaSelected.victim.genre }}</strong><br/>
            <strong>Natureza: {{ fixaSelected.reason }}</strong><br/>
            <strong>Tipo: {{ fixaSelected.type }}</strong><br/>
            <strong>Solicitante: {{ fixaSelected.name }} - {{ fixaSelected.phone }}</strong>
          </v-col>

          <v-col
            class="py-0 my-0"
            cols="6">
            <v-btn
              class="px-3 ml-2 caption primary--text"
              depressed
              @click="dialogCancelar = true">
              Cancelar Solicitação
              <v-icon size="12" class="ml-1">far fa-trash-alt</v-icon>
            </v-btn>
            <br/><br/>
            <v-select
              class="mt-1 mb-5"
              v-model="fixaSelected.consciousness_state"
              :rules="stateConsciousnessRules"
              :items="estadosConsciencia"
              label="Estado de consciência"
              outlined
              dense>
            </v-select>
          </v-col>
        </v-row>
      </v-form>

      <v-layout
        class="my-0"
        row
        wrap>

        <v-container
          fluid
          class="pa-0 my-0 mb-0 ml-0 mr-0 mx-0">
          <v-row>
            <v-col
              cols="12"
              xs="12">
              <v-textarea
                v-model="fixaSelected.evaluation"
                outlined
                name="input-7-4"
                label="Avaliações"
                persistent-hint
                value=""
                hide-details>
              </v-textarea>
            </v-col>
          </v-row>
        </v-container>

        <v-flex
          class="text-right"
          xs12 sm12 md12 lg12>
          <v-card class="elevation-0 my-0">

            <v-card-title
              class="py-0 subtitle-1">
              <strong>Risco Comprovado</strong>
            </v-card-title>

            <v-card-text class="py-0">
              <v-form
                ref="formEvaluationThree"
                lazy-validation>
                <v-radio-group
                  height="50"
                  v-model="classification"
                  class="mt-0 mb-1 py-0 px-0 primary--text"
                  :rules="classificationRules"
                  :column="$vuetify.breakpoint.name === 'xs'?true:false">

                  <v-radio
                    class="blue--text"
                    value="emergencia">
                    <template v-slot:label>
                      <div class="primary--text">
                        Emergência
                      </div>
                    </template>
                  </v-radio>

                  <v-radio
                    class="primary--text"
                    value="muito-urgente">
                    <template v-slot:label>
                      <div class="primary--text">
                        Muito Urgente
                      </div>
                    </template>
                  </v-radio>

                  <v-radio
                    class="primary--text"
                    value="urgente">
                    <template v-slot:label>
                      <div class="primary--text">
                        Urgente
                      </div>
                    </template>
                  </v-radio>

                  <v-radio
                    class="primary--text"
                    value="pouco-urgente">
                    <template v-slot:label>
                      <div class="primary--text">
                        Pouco Urgente
                      </div>
                    </template>
                  </v-radio>

                  <v-radio
                    class="primary--text"
                    value="nao-urgente">
                    <template v-slot:label>
                      <div class="primary--text">
                        Não Urgente
                      </div>
                    </template>
                  </v-radio>
                </v-radio-group>
                <v-progress-linear
                  v-if="corClassification"
                  :style="classification !== '' ? 'visibility: visible;':'visibility: hidden;'"
                  class="my-3"
                  v-model="valueDeterminate"
                  :color="corClassification"
                  height="15">
                </v-progress-linear>
              </v-form>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex
          class="text-right"
          xs12 sm12 md12 lg12>
          <v-card class="elevation-0 my-0">

            <v-card-title class="subtitle-1 py-0">
              <strong>Tipo de veículo</strong>
              <span
                v-if="errorFormVehicle"
                class="red--text ml-8">
              É necessário escolher um veículo!
            </span>
            </v-card-title>

            <v-card-text
              class="py-0"
              style="background-color:transparent;">
              <form
                ref="formEvaluationFour"
                lazy-validation>
                <v-item-group
                  v-model="vehicle"
                  active-class="indigo"
                  :rules="vehiclesRules">
                  <v-row>
                    <v-col
                      v-for="n in v"
                      :key="n.name"
                      cols="2">
                      <v-item
                        :value="n"
                        v-slot:default="{ active, toggle }">
                        <v-card
                          class="d-flex align-center"
                          outlined
                          style="border-color: indigo; border-width:1px"
                          height="45"
                          @click="toggle">
                          <v-scroll-y-transition>

                            <div
                              v-if="active"
                              class="flex-grow-1 text-center indigo--text">
                              <v-btn text>
                              <span class="white--text">
                                {{n.name}}
                              </span>
                                <v-icon color="white" large>
                                  {{n.icon}}
                                </v-icon>
                              </v-btn>
                            </div>

                            <div
                              v-else
                              class="flex-grow-1 text-center indigo--text">
                              <v-btn text>
                              <span>
                                {{n.name}}
                              </span>
                                <v-icon class="ml-1" large>
                                  {{n.icon}}
                                </v-icon>
                              </v-btn>
                            </div>
                          </v-scroll-y-transition>
                        </v-card>
                      </v-item>
                    </v-col>
                  </v-row>
                </v-item-group>
              </form>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-container class="py-0 px-0">
          <v-layout wrap class="align-end justify-end">
          <span
            v-if="errorNotEvaluations"
            class="red--text">
            É necessário avaliar todas as vítimas!
          </span>
          </v-layout>
          <v-spacer>
          </v-spacer>
        </v-container>
      </v-layout>

      <v-spacer>
      </v-spacer>

      <v-dialog
        v-model="dialogCancelar"
        width="400"
        persistent>
        <v-card>

          <v-card-title
            class="headline"
            primary-title>
            Cancelar Solicitação
          </v-card-title>

          <v-card-text>

            <v-text-field
              v-model="fixaSelected.phone"
              label="Telefone"
              outlined
              dense
              readonly
              hide-details>
            </v-text-field>

            <br/><br/>

            <v-textarea
              hide-details
              outlined
              label="Motivo"
              v-model="descricaoInformacao">
            </v-textarea>

            <span
              v-show="!descricaoInformacao"
              style="color: red">
            *campo motivo é obrigatório*
          </span>

            <div
              v-if="errorDelete"
              class="errorText">
              {{errorDelete}}
            </div>
          </v-card-text>


          <v-divider></v-divider>

          <v-card-actions>

            <v-spacer>
            </v-spacer>

            <v-btn
              color="primary"
              text
              @click="dialogCancelar = false">
              Não
            </v-btn>

            <v-btn
              color="primary"
              :loading="loading"
              text
              @click="cancelEvaluation()"
              :disabled="!descricaoInformacao">
              Sim
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-text>
  </v-card>
</template>

<script>
export default {

  name: "StepEvaluation",

  props: ['callObj'],

  data: () => ({
    dialogCancelar: false,
    descricaoInformacao: undefined,
    avaliation: '',
    coloracoes: ["Pálida", "Cianose(arroxeada)"],
    coloracao: "",
    loading: false,
    pulsos: ["Sem Pulso", "Pulso Fraco", "Pulso Normal", "Pulso Rápido"],
    estadosConsciencia: [
      "CONSCIENTE",
      "INCONSCIENTE",
    ],
    respiracoes: [
      "Eupnéia",
      "Apnéia",
      "Bradipnéia",
      "Taquipnéia",
      "Ortopnéia",
      "Hiperpnéia",
    ],
    v: [
      { name: "USA", icon: "fas fa-ambulance" },
      { name: "VIR", icon: "airport_shuttle" },
      { name: "USB", icon: "fas fa-ambulance" },
      //{ name: "HEL", icon: "fa fa-helicopter" },
      { name: "MOT", icon: "fa fa-motorcycle" },
      { name: "LAN", icon: "directions_boat" },
      //{ name: "VTI", icon: "fas fa-truck" },
    ],
    vehicle: undefined,

    pacienteSelecionado: "",
    estadoConsciencia: "",
    pulso: "",
    respiracao: "",
    corClassification: "",
    classification: "",
    valueDeterminate: 100,
    stateConsciousnessRules: [
      (v) => !!v || "É necessário definir o estado de consciência da vítima!",
    ],
    coloringRules: [
      (v) => !!v || "É necessário definir a coloração da pele da vítima!",
    ],
    pulseRules: [(v) => !!v || "É necessário definir o pulso da vítima!"],
    breathingRules: [
      (v) => !!v || "É necessário definir a respiração da vítima!",
    ],
    classificationRules: [
      (v) => !!v || "É necessário definir a classificação de risco da vítima!",
    ],
    vehiclesRules: [(v) => !!v || "kjhkjhk"],
    errorFormVehicle: false,
    evaluations: [],
    errorNotEvaluations: false,
    fixaSelected: {//fixaSelected.consciousness_state
      phone:'',
      victim: {
        name: '',
        age: '',
        genre: '',
      },
      reason: '',
      type: '',
      evaluation: "",
      proven_risk: "",
      consciousness_state: "",
      vehicle_type:  "",
    },
    errorDelete: undefined,
  }),

  created () {

  },

  computed: {

    isValid () {
      let valid = this.fixaSelected.id &&
        this.fixaSelected.evaluation  && this.fixaSelected.evaluation != "" &&
        this.fixaSelected.proven_risk  && this.fixaSelected.proven_risk != "" &&
        this.fixaSelected.consciousness_state  && this.fixaSelected.consciousness_state != "" &&
        this.fixaSelected.vehicle_type  && this.fixaSelected.vehicle_type != "" ;
      return valid;
    },

    callSelected (){
      return this.$store.getters.call;
    },
  },

  watch: {

    dialogCancelar (newValue ){
      if(newValue==false){
        this.descricaoInformacao =""
      }
    },

    vehicle (v) {
      this.fixaSelected.vehicle_type = v.name;
    },

    callSelected (v) {
      if (v){
        this.fixaSelected  = v;
        console.log('fez check',v)
        if(v.vehicle_type){
          this.v.forEach( item => {
            console.log('fez check',v.vehicle_type,v)
            if(item.name == v.vehicle_type){
              this.vehicle = item;
            }
          })
        }
      }
      else{
        this.setDefaultSelect();
      }
    },

    classification(value) {
      this.fixaSelected.proven_risk = value;
      if (value === "emergencia") this.corClassification = "red";
      else if (value === "muito-urgente") this.corClassification = "orange";
      else if (value === "urgente") this.corClassification = "amber";
      else if (value === "pouco-urgente") this.corClassification = "green";
      else this.corClassification = "blue";
    }


  },

  methods: {

    resetForm (v) {
      this.$refs.form.reset();
    },

    setDefaultSelect () {
      let fixa = {
        call: {
          phone:'',
          victim: {
            name: '',
            age: '',
            genre: '',
          },
          reason: '',
          type: '',
        },
      };
      this.fixaSelected = Object.assign({}, fixa);
    },

    setEvaluationVictim() {
      let validate = this.$refs.formEvaluationOne.validate() && this.vehicle;
      /* this.$refs.formEvaluationTwo.validate() &&
      this.$refs.formEvaluationThree.validate() && */
      if (validate && this.patients.length > 0) {
        let evaluation = {
          consciousness: this.estadoConsciencia,
          pulse: this.pulso,
          breathing: this.breathing,
          classification: this.classification,
          vehicle: this.vehicle,
          coloring: this.coloracao,
        };
        this.evaluations.push({
          ...this.pacienteSelecionado,
          evaluation: { ...evaluation },
        });
        this.errorFormVehicle = false;
        if(this.$refs.formEvaluationOne){
          this.$refs.formEvaluationOne.reset();
          this.$refs.formEvaluationOne.resetValidation();
        }
        if(this.$refs.formEvaluationTwo){
          this.$refs.formEvaluationTwo.reset();
          this.$refs.formEvaluationTwo.resetValidation();
        }
        if(this.$refs.formEvaluationThree){
          this.$refs.formEvaluationThree.reset();
          this.$refs.formEvaluationThree.resetValidation();
          this.vehicle = undefined;
        }
      }
      else {
        this.errorFormVehicle = true;
      }
    },

    clearStep() {
      this.setDefaultSelect();
      this.$store.dispatch("setSolicitationInfoCall", undefined);
      this.evaluations = []
      if( this.$refs.formEvaluationOne){
        this.$refs.formEvaluationOne.reset();
        this.$refs.formEvaluationOne.resetValidation();
      }

      if( this.$refs.formEvaluationTwo){
        this.$refs.formEvaluationTwo.reset();
        this.$refs.formEvaluationTwo.resetValidation();
      }

      if( this.$refs.formEvaluationThree){
        this.$refs.formEvaluationThree.reset();
        this.$refs.formEvaluationThree.resetValidation();
        this.vehicle = undefined;
      }
    },

    setEvaluationInfoCall() {
      if (this.patients.length == 0) {
        this.$store.dispatch("setVictimsInfoCall", this.evaluations);
        this.errorNotEvaluations = true;
        return true;
      }
      this.errorNotEvaluations = true;
      return false
    },

    async cancelEvaluation () {
      let fixaDeliting = {
        id: this.fixaSelected.id,
        "cancellation_reason": this.descricaoInformacao,
      }
      let canceled = await this.$store.dispatch("removeEmergency", fixaDeliting)
        .then( resolve =>{
          return resolve;
        })
        .catch( e => {
          return e;
        })

      if (canceled.status){
        let load = await this.$store.dispatch("loadAttendances");
        this.clearStep();
      }
      else{
        console.log(JSON.stringify( canceled, null, ' '));
        this.setErrorDelete(canceled.message);
      }
    },

    setErrorDelete (errorMsg) {
      this.errorDelete = errorMsg;
      setTimeout(() => {
        //this.errorDelete = undefined;
      }, 5000);
    },
  },
};
</script>

<style>
.errorText{
  align-items: center;
  text-align: center;
  color: crimson;
  background: khaki;
}
</style>
